export default {"src":"https://fishbrain.com/_next/static/media/southCarolina.6f3306ae.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};